<template>
    <div id="login" class="login-card mt-6">
        <div class="logo-app px-6 py-4">
            <img
                :src="require('@/assets/images/logo_eduloc360_red.png')"
                class="mt-4"
            />
        </div>
        <p class="has-text-centered is-size-4 px-6">
            {{ $t('login.form_title') }}
        </p>
        <p class="has-text-centered is-size-6 secondary-font px-6">
            {{ $t('login_subtitle') }}
        </p>

        <form  action @submit.prevent class="py-4 px-6">
            <div class="field is-expanded">
                <div class="field">
                    <div class="control is-expanded">
                        <input
                            v-model="input.username"
                            :placeholder="$t('login.enter_username_email')"
                            autocomplete="username email"
                            type="text"
                            name="username"
                            class="input eduloc"
                            @input="errorLogin = false"
                        />
                    </div>
                </div>
            </div>
            <div class="field is-expanded">
                <div class="field">
                    <div class="control is-expanded">
                        <input
                            v-model="input.password"
                            :placeholder="$t('login.enter_password')"
                            type="password"
                            name="password"
                            autocomplete="current-password"
                            class="input eduloc"
                            @input="errorLogin = false"
                        />
                    </div>
                    <a class="is-size-7 secondary-font has-text-right is-block" @click="changePassword=true">{{ $t("forgot_password") }}</a>
                </div>
            </div>
            <div class="errors">
                <span
                    v-if="errorLogin"
                    v-t="errorLoginText"
                    class="has-text-danger is-block pb-3 pt-0 has-text-centered"
                />
            </div>
            <div class="control">
                <button
                    v-t="'login.start'"
                    :disabled="emptyFields"
                    :class="{ 'is-loading': loading }"
                    class="login-button button is-medium is-fullwidth"
                    @click="login"
                ></button>
            </div>
        </form>
        <section class="section pt-2 pb-4">
            <p class="has-text-centered is-size-7 secondary-font">{{ $t('registration_text')}} <a @click="showRegistration=true">{{ $t('here') }}</a>. </p>
            <p class="has-text-centered is-size-7 secondary-font">{{ $t('validation_text')}} <a @click="showValidation=true">{{ $t('here') }}</a> </p>
            <p class="has-text-centered is-size-7 secondary-font pb-4">{{ $t('login_with_others')}}.</p>
            <div v-if="!showLoginForm" class="">
                
                <a
                    class="login-button button is-medium is-fullwidth"
                    @click="loginWithGoogle"
                >
                    <span class="logo">
                        <img
                            :src="require('@/assets/images/logo_google.png')"
                            class=""
                        />
                    </span>
                    <span class="logo-text is-size-7 secondary-font">{{$t('login_google')}}</span>
                </a>
                <a
                    class="login-button button is-medium is-fullwidth mt-3"
                    @click="loginWithMicrosoft"
                >
                    <span class="logo">
                        <img
                            :src="require('@/assets/images/logo_microsoft.png')"
                            class=""
                        />
                    </span>
                    <span class="logo-text is-size-7 secondary-font">{{$t('login_microsoft')}}</span>
                </a>
            </div>
        </section>

        <section class="section pt-0 pb-0">
            <p class="has-text-centered is-size-7 secondary-font">
                {{ $t('login_on_register') }}
                <a href="https://www.eduloc360.com/terminos-y-condiciones-de-uso-de-eduloc-360/" target="_blank">{{$t('login_terms_and_conditions')}}</a>
                <!--<router-link tag="a" class="" to="/tos">{{
                    $t('login_terms_and_conditions')
                }}</router-link>-->
            </p>
            <!--<p class="has-text-centered is-size-7 secondary-font">
                {{ $t('login_read') }}
                <a href="https://www.eduloc360.com/politica-de-privacidad/" target="_blank">{{$t('login_privacy_policy')}}</a>
                
            </p>-->
            <p class="has-text-centered is-size-7 secondary-font pt-4 pb-6" v-html="$t('login_disclaimer')"/>
            
            <!--<p class="has-text-centered is-size-7 secondary-font pt-5 pb-4">
                <a href="https://www.eduloc360.com/aviso-legal/" target="_blank">{{$t('legal_advice')}}</a> - <a href="https://www.eduloc360.com/politica-de-cookies/" target="_blank">{{$t('cookies_policy')}}</a>
            </p>-->
        </section>

        <app-modal-view class="shareModal registration" v-if="showRegistration">
            <template #header>
                <p class="is-size-4 has-text-black">{{ $t('registration_title') }}</p>
            </template>
            <template #body>
                <div class="columns">
                    <div class="column">
                        <div class="field">
                            <label class="label">{{ $t('registration_name') }}</label>
                            <div class="control has-icons-right">
                                <input class="input eduloc" type="text" v-model="registrationData.name" :class="showNameError?'is-danger':''" @change="checkNameField">
                                <span class="icon is-small is-right" v-if="showNameError">
                                    <i class="fas fa-exclamation-triangle has-text-danger"></i>
                                </span>
                            </div>
                            <p class="help is-danger is-size-7" v-if="showNameError">{{ $t(errorsFound.name) }}</p>
                        </div>
                    </div>
                    <div class="column">
                        <div class="field">
                            <label class="label">{{ $t('registration_surname') }}</label>
                            <div class="control has-icons-right">
                                <input class="input eduloc" type="text" v-model="registrationData.surname" :class="showSurnameError?'is-danger':''" @change="checkSurnameField">
                                <span class="icon is-small is-right" v-if="showSurnameError">
                                    <i class="fas fa-exclamation-triangle has-text-danger"></i>
                                </span>
                            </div>
                            <p class="help is-danger is-size-7" v-if="showSurnameError">{{ $t(errorsFound.surname) }}</p>
                        </div>
                    </div>
                </div>
                <div class="columns">
                    <div class="column">
                        <div class="field">
                            <label class="label">{{ $t('registration_username') }}</label>
                            <div class="control has-icons-right">
                                <input class="input eduloc" type="text" v-model="registrationData.username" :class="showUsernameError?'is-danger':''" @change="checkUsernameField">
                                <span class="icon is-small is-right" v-if="showUsernameError">
                                <i class="fas fa-exclamation-triangle has-text-danger"></i>
                                </span>
                            </div>
                            <p class="help is-danger is-size-7" v-if="showUsernameError"> {{ $t(errorsFound.username) }}</p>
                        </div>
                    </div>
                    <div class="column">
                        <div class="field">
                            <label class="label">{{ $t('registration_email') }}</label>
                            <div class="control has-icons-right">
                                <input class="input eduloc" type="email" v-model="registrationData.email" :class="showEmailError?'is-danger':''" @change="checkEmailField">
                                <span class="icon is-small is-right" v-if="showEmailError">
                                <i class="fas fa-exclamation-triangle has-text-danger"></i>
                                </span>
                            </div>
                            <p class="help is-danger is-size-7" v-if="showEmailError">{{ $t(errorsFound.email) }}</p>
                        </div>
                    </div>
                </div>
                <div class="columns">
                    <div class="column">
                        <div class="field">
                            <label class="label">{{ $t('registration_password') }}</label>
                            <div class="control has-icons-right">
                                <input class="input eduloc" type="password" v-model="registrationData.password" :class="showPw1Error?'is-danger':''" @change="checkPasswordField">
                                <span class="icon is-small is-right is-danger" v-if="showPw1Error">
                                <i class="fas fa-exclamation-triangle has-text-danger"></i>
                                </span>
                            </div>
                            <p class="help is-danger is-size-7" v-if="showPw1Error">{{ $t(errorsFound.pw1) }}</p>
                        </div>
                    </div>
                    <div class="column">
                        <div class="field">
                            <label class="label">{{ $t('registration_password_confirmation') }}</label>
                            <div class="control has-icons-right">
                                <input class="input eduloc" type="password" v-model="registrationData.pw2" :class="showPw2Error?'is-danger':''" @change="checkPasswordField"> 
                                <span class="icon is-small is-right" v-if="showPw2Error">
                                <i class="fas fa-exclamation-triangle has-text-danger"></i>
                                </span>
                            </div>
                            <p class="help is-danger is-size-7" v-if="showPw2Error">{{ $t(errorsFound.pw2) }}</p>
                        </div>
                    
                    </div>
                </div>
                <div class="columns">
                    <div class="column is-narrow pt-0 pr-0 has-text-left">
                        <span class="icon is-medium is-clickable " @click="toogleAgeConsent">
                            <i class="mdi mdi-32px has-text-black"
                                :class="ageConsent ? 'mdi-checkbox-marked-outline' : 'mdi-checkbox-blank-outline'" />
                        </span>
                    </div>
                    <div class="column pt-0 has-text-left">
                        <p class="pt-1">{{$t('confirm_age_text')}}</p>
                    </div>
                    
                </div>
                <div class="columns">
                    <div class="column is-narrow pt-0 pr-0 has-text-left">
                        <span class="icon is-medium is-clickable" @click="toogleTOS">
                            <i class="mdi mdi-32px has-text-black"
                                :class="TOSaccepted ? 'mdi-checkbox-marked-outline' : 'mdi-checkbox-blank-outline'" />
                        </span>
                    </div>
                    <div class="tos-desc column has-text-left pt-0">
                        <p class="pt-1" v-html="$t('confirm_tos_text')"/>
                    </div>
                    
                </div>
            
            </template>
            <template #footer>
                <div class="columns">
                    <div class="column px-6 pb-5">
                        <div class="has-text-right">
                        <button class="button is-primary" @click="checkForm" :disabled="isDisabled">{{ $t('send') }}</button>
                        <button class="button is-secondary" @click="showRegistration=false">{{ $t('close') }}</button>
                    </div>
                    </div>
                </div>
            </template>
        </app-modal-view>

        <app-modal-view class="shareModal activation" v-if="showValidation">
            <template #header>
                <p v-if="registrationOk" class="is-size-4 has-text-black">{{ $t('user_registered_successfuly_title') }}</p>
                <p v-else class="is-size-4 has-text-black">{{ $t('account_activation_title') }}</p>
            </template>
            <template #body>
                <p class="has-text-black pb-4" v-if="registrationOk">{{$t('user_registered_successfuly_text')}}</p>
                <p class="has-text-black pb-4" v-else>{{$t('account_activation_text')}}</p>
                <div class="columns">
                    <div class="column">
                        <div class="field">
                            <label class="label">{{ $t('activation_code') }}</label>
                            <div class="control has-icons-right">
                                <input class="input eduloc" type="text" v-model="activationCode" :class="showActivationCodeError?'is-danger':''">
                                <span class="icon is-small is-right is-danger" v-if="showActivationCodeError">
                                <i class="fas fa-exclamation-triangle has-text-danger"></i>
                                </span>
                            </div>
                            <p class="help is-danger is-size-7" v-if="showActivationCodeError">{{ $t('activation_code_error') }}</p>
                        </div>
                    </div>
                </div>
            </template>
            <template #footer>
                <div class="columns">
                    <div class="column px-6 pb-5">
                        <div class="has-text-right">
                            <button class="button is-primary" @click="sendCode">{{ $t('send') }}</button>
                            <button class="button is-secondary" @click="showValidation=false">{{ $t('close') }}</button>
                        </div>
                    </div>
                </div>

            </template>
        </app-modal-view>

        <app-modal-view @close="logout" class="shareModal consent" v-if="showAgeModal">
            <template #header>
                <div class="header-project">
                    <div class="navbar-menu">
                        <div class="navbar-start">
                            <router-link :to="'/'" class="navbar-item is-marginless">
                                <img
                                    src="@/assets/images/logo_eduloc360.png"
                                    alt="eduloc360"
                                    width="160"
                                    height="50"
                                />
                            </router-link>
                        </div>
                        <div class="navbar-end">
                            <div class="navbar-item has-dropdown is-hoverable">
                                <a class="navbar-link is-arrowless">
                                    <!--<span class="icon has-text-white"><i class="mdi mdi-28px mdi-web"></i></span>-->
                                    <span class="icon mr-1"><i class="mdi mdi-18px mdi-web"></i></span>
                                    {{ $i18n.locale | localePrint }}
                                </a>
                                <div class="navbar-dropdown is-right">
                                    <a
                                        v-for="locale in locales"
                                        :key="locale"
                                        @click="switchLocale(locale)"
                                        class="navbar-item has-text-black"
                                    >
                                        {{ locale | localePrint }}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <template #body>
                <p class="secondary-font pb-4 px-6" v-if="!$store.getters.hasMinimumAge">{{$t('confirm_age_intro')}}</p>
                <div class="columns is-mobile pt-1 mb-0 pr-0 is-centered" v-if="!$store.getters.hasMinimumAge">
                    <div class="column is-6 pt-0 has-text-right">
                        <p class="pt-1">{{$t('confirm_age_text')}}</p>
                    </div>
                    <div class="column is-2 pt-0 has-text-left">
                        <span class="icon is-medium is-clickable" @click="toogleAgeConsent">
                            <i class="mdi mdi-32px"
                                :class="ageConsent ? 'mdi-checkbox-marked-outline has-text-primary' : 'mdi-checkbox-blank-outline has-text-black'" />
                        </span>
                    </div>
                </div>
                <div class="columns is-mobile pt-0 mb-0 pr-0 is-centered" v-if="!$store.getters.TOSAccepted">
                    <div class="tos-desc column is-6 has-text-right pt-0">
                        <p class="pt-1" v-html="$t('confirm_tos_text')"/>
                    </div>
                    <div class="column is-2 pt-0 has-text-left">
                        <span class="icon is-medium is-clickable" @click="toogleTOS">
                            <i class="mdi mdi-32px"
                                :class="TOSaccepted ? 'mdi-checkbox-marked-outline has-text-primary' : 'mdi-checkbox-blank-outline has-text-black'" />
                        </span>
                    </div>
                </div>
                <!--<div class="secondary-font pb-4 px-6 pt-4" v-if="$store.getters.personalData.invitation">
                    
                        <p class="pt-1 secondary-font has-text-weight-normal">{{$t('entity_invitation_announcment')}}&nbsp;<span class="has-text-weight-bold">{{ $store.getters.personalData.invitation.entity }}</span></p>
                        <p class="pt-1 secondary-font">{{$t('entity_invitation_confirmation')}}</p>
                    
                </div>
                <div class="columns is-mobile pt-4 mb-0 pr-0 is-centered" v-if="$store.getters.personalData.invitation">
                    <div class="column is-8 pt-0 has-text-center">
                        <div class="buttons has-addons is-centered pt-2">
                            <button class="button has-text-weight-bold" :class="invitationConfirmed ? 'is-eduloc-blue is-selected': ''" @click="confirmInvitation">{{$t('entity_invitation_confirm')}}</button>
                            <button class="button has-text-weight-bold" :class="invitationdeclined ? 'is-eduloc-blue is-selected': ''" @click="declineInvitation">{{$t('entity_invitation_decline')}}</button>
                        </div>
                        
                    </div>
                </div>-->
                <div class="columns is-mobile pt-6 mb-0 pr-0 is-centered pt-4" >
                    <div class="column is-narrow">
                        <button @click="updateProfile" class="button is-primary primary-font" :disabled="updateEnabled ? false : true">{{$t('confirm')}}</button>
                    </div>
                </div>
            </template>
        </app-modal-view>

        <app-modal-view class="shareModal activation" v-if="changePassword">
            <template #header>
                <p class="is-size-4 has-text-black">{{ $t('forgot_password_title') }}</p>
            </template>
            <template #body>
                <p class="has-text-black pb-4 secondary-font">{{$t('forgot_password_text')}}</p>
                <div class="columns">
                    <div class="column">
                        <div class="field">
                            <label class="label">{{ $t('forgot_password_email') }}</label>
                            <div class="control has-icons-right">
                                <input class="input eduloc" type="text" v-model="forgotPasswordEmail" :class="showForgotPasswordError?'is-danger':''">
                                <span class="icon is-small is-right is-danger" v-if="showForgotPasswordError">
                                <i class="fas fa-exclamation-triangle has-text-danger"></i>
                                </span>
                            </div>
                            <p class="help is-danger is-size-7" v-if="showForgotPasswordError">{{ $t('forgot_password_error') }}</p>
                        </div>
                    </div>
                </div>
            </template>
            <template #footer>
                <div class="columns">
                    <div class="column px-6 pb-5">
                        <div class="has-text-right">
                            <button class="button is-primary" @click="sendForgotPasswordRequest">{{ $t('send') }}</button>
                            <button class="button is-secondary" @click="changePassword=false">{{ $t('close') }}</button>
                        </div>
                    </div>
                </div>

            </template>
        </app-modal-view>

        <app-modal-view class="shareModal activation" v-if="changePasswordCodeInput">
            <template #header>
                <p v-if="!pwChanged" class="is-size-4 has-text-black">{{ $t('forgot_password_code_title') }}</p>
                <p v-else class="is-size-4 has-text-black">{{ $t('forgot_password_changed_title') }}</p>
            </template>
            <template #body>
                <div v-if="!pwChanged">
                    <p class="has-text-black pb-4 secondary-font">{{$t('forgot_password_code_text')}}</p>
                    <div class="columns">
                        <div class="column">
                            <div class="field">
                                <label class="label">{{ $t('forgot_password_code') }}</label>
                                <div class="control has-icons-right">
                                    <input class="input eduloc" type="text" v-model="forgotPasswordCode" :class="showForgotPasswordCodeError?'is-danger':''">
                                    <span class="icon is-small is-right is-danger" v-if="showForgotPasswordCodeError">
                                    <i class="fas fa-exclamation-triangle has-text-danger"></i>
                                    </span>
                                </div>
                                <p class="help is-danger is-size-7" v-if="showForgotPasswordCodeError">{{ $t('forgot_password_code_error') }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="columns">
                        <div class="column is-6">
                            <div class="field">
                                <label class="label">{{ $t('registration_password') }}</label>
                                <div class="control has-icons-right">
                                    <input class="input eduloc" type="password" v-model="password" :class="showForgotPw1Error?'is-danger':''" @change="checkChangePasswordField">
                                    <span class="icon is-small is-right is-danger" v-if="showForgotPw1Error">
                                    <i class="fas fa-exclamation-triangle has-text-danger"></i>
                                    </span>
                                </div>
                                <p class="help is-danger is-size-7" v-if="showForgotPw1Error">{{ $t(forgoterrorsFound.pw1) }}</p>
                            </div>
                        </div>
                        <div class="column is-6">
                            <div class="field">
                                <label class="label">{{ $t('registration_password_confirmation') }}</label>
                                <div class="control has-icons-right">
                                    <input class="input eduloc" type="password" v-model="pw2" :class="showForgotPw2Error?'is-danger':''" @change="checkChangePasswordField"> 
                                    <span class="icon is-small is-right" v-if="showForgotPw2Error">
                                    <i class="fas fa-exclamation-triangle has-text-danger"></i>
                                    </span>
                                </div>
                                <p class="help is-danger is-size-7" v-if="showForgotPw2Error">{{ $t(forgoterrorsFound.pw2) }}</p>
                            </div>
                        
                        </div>
                    </div>
                </div>
                <div v-else>
                    <p class="has-text-black pb-4 secondary-font">{{$t('forgot_password_changed_text')}}</p>
                </div>
            </template>
            <template #footer>
                <div class="columns">
                    <div class="column px-6 pb-5">
                        <div class="has-text-right">
                            <button v-if="!pwChanged" class="button is-primary" @click="sendForgotPasswordRequestCode">{{ $t('send') }}</button>
                            <button class="button is-secondary" @click="closeChangePasswordModal">{{ $t('close') }}</button>
                        </div>
                    </div>
                </div>

            </template>
        </app-modal-view>
        
    </div>
</template>
<script>
import AuthService from '@/services/auth.service';
import AppModalView from '@/components/AppModalView';
import qs from 'qs';
import _ from 'underscore';
import { changePassword, requestPassword, checkUsername, checkEmail, register, activateUser } from '@/services/API';
import Swal from 'sweetalert2';
export default {
    components: {
        AppModalView,
    },
    name: 'Loginlocal',
    data() {
        return {
            input: {
                username: '',
                password: '',
            },
            errorLogin: false,
            loading: false,
            showLoginForm: false,
            alias: '',
            registrationData: {
                name: '',
                surname: '',
                email: '',
                username: '',
                password: '',
                pw2: '',
                TOSaccepted: false,
                ageConsent: false,
                type: 'LOCAL',
            },
            errorsFound: {},
            showRegistration: false,
            ageConsent: false,
            TOSaccepted: false,
            showNameError: false,
            showSurnameError: false,
            showUsernameError: false,
            showEmailError: false,
            showPw1Error: false,
            showPw2Error: false,
            errorLoginText: this.$t('login.error'),
            showValidation: false,
            changePassword: false,
            activationCode: '',
            registrationOk: false,
            showActivationCodeError: false,
            showAgeModal: false,
            locales: process.env.VUE_APP_I18N_SUPPORTED_LOCALE.split(','),
            ageConsent: false,
            user: this.$store.getters.personalData,
            TOSaccepted: false,
            invitationConfirmed: false,
            invitationdeclined: false,
            forgotPasswordEmail: '',
            showForgotPasswordError: false,
            changePasswordCodeInput: false,
            forgotPasswordCode: '',
            showForgotPasswordCodeError: false,
            password: '',
            pw2:'',
            showForgotPw1Error: false,
            showForgotPw2Error: false,
            forgoterrorsFound: {},
            pwChanged: false,
        };
    },
    filters: {
        localePrint(locale) {
            return locale.slice(0, 2).toUpperCase();
        },
    },
    props: {
        code: { type: String, default: undefined },
        token: { type: String, default: undefined },
        idToken: { type: String, default: undefined },
        access_token: { type: String, default: undefined },
        lb: { type: String, default: undefined },
    },
    computed: {
        emptyFields: function () {
            return this.input.username == '' || this.input.password == '';
        },
        isDisabled: function () {
            // console.log("has errors?", this.hasErrors,this.registrationData)
            if (this.hasErrors) {
                return true;
            } else if (this.registrationData.name && this.registrationData.surname && this.registrationData.email && this.registrationData.password && this.registrationData.pw2 && this.registrationData.username && this.registrationData.TOSaccepted && this.registrationData.ageConsent) {
                return false;
            }
            return true;
        },
        hasErrors() {
            // console.log(this.showNameError, this.showSurnameError, this.showUsernameError, this.showEmailError, this.showPw1Error, this.showPw2Error)
            return this.showNameError || this.showSurnameError || this.showUsernameError || this.showEmailError || this.showPw1Error | this.showPw2Error;
        },
        hasUpdatePasswordErrors() {
            // console.log(this.showForgotPasswordCodeError, this.showForgotPw1Error, this.showForgotPw2Error)
            return this.showForgotPasswordCodeError || this.showForgotPw1Error || this.showForgotPw2Error;
        },
        updateEnabled() {
            /*if (this.$store.getters.personalData && this.$store.getters.personalData.invitation) {
                return this.ageConsent&&this.TOSaccepted&&(this.invitationConfirmed||this.invitationdeclined)
            } else {*/
                return this.ageConsent&&this.TOSaccepted
            //}
        },
    },
    created() {
        // console.log('created auth service');
        this.authService = new AuthService();
    },
    destroyed() {
        //alert('aqui');
        localStorage.removeItem('createProject');
    },
    methods: {
        login() {
            this.loading = true;
            this.$store
                .dispatch('localLogin', {
                    username: this.input.username,
                    password: this.input.password,
                })
                .then((response) => {
                    // console.log("i ara?",this.$store.getters.user)
                    if(!this.$store.getters.hasMinimumAge || !this.$store.getters.TOSAccepted || this.$store.getters.personalData.invitation ){
                        // console.log("Show confirm age modal");
                        if(this.$store.getters.hasMinimumAge){
                            this.ageConsent = this.$store.getters.hasMinimumAge;
                        }
                        if(this.$store.getters.TOSAccepted){
                            this.TOSaccepted = this.$store.getters.TOSAccepted;
                        }
                        this.showAgeModal=true;
                    }else{
                        // console.log("to enter plattform")
                        this.enterPlatform();
                    }

                    //console.log(response)
                    //if (response && response.status == "200") {
                    /*this.$router.push({
                        name: 'dashboard',
                        query: {
                            filter: 'mine',
                        },
                    });*/
                    //}
                })
                .catch((e) => {
                    // console.log("login error detected",e.status)
                    if (e && e.status == '401') {
                        // console.log("error recived")
                        if (e.data.message == "Invalid credentials.") {
                            this.errorLoginText = this.$t('login.error');
                            this.errorLogin = true;
                        } else if (e.data.message == "ERROR_LOGIN_MISSING_ENTITY") { 
                            Swal.fire({
                                title: this.$t('user_login_failed'),
                                html: this.$t(e.data.message),
                                confirmButtonText: this.$t('userProfile.leave_school_continue')
                            }).then((result) => {
                                this.logout();
                            });
                            this.errorLogin = false;
                        } else {
                            this.errorLoginText = this.$t(e.data.message);
                            this.errorLogin = true;
                        }
                        
                    }
                    //this.errorLogin = true;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        loginWithGoogle() {
            let loginURL = new URL(
                'https://accounts.google.com/o/oauth2/v2/auth'
            );
            let params = new URLSearchParams(loginURL.search.slice(1));
            params.append('access_type', 'offline');
            params.append('include_granted_scopes', true);
            params.append(
                'redirect_uri',
                process.env.VUE_APP_GOOGLE_REDIRECT_URI
            );
            params.append('client_id', process.env.VUE_APP_GOOGLE_CLIENT_ID);
            params.append('response_type', 'code');
            params.append('scope', 'email profile openid');
            params.append('prompt', 'consent');
            window.location = `${loginURL}?${params.toString()}`;
        },
        loginWithMicrosoft() {
            this.authService.login().then(
                (idToken) => {
                    if (idToken) {
                        this.performLogin(idToken);
                    }
                },
                () => { }
            );
        },
        performLogin(idToken) {
            const query = qs.parse(
                qs.stringify(this.$route.query, { format: 'RFC1738' }),
                {
                    decoder: (c) => decodeURIComponent(c),
                }
            );
            // console.log('IN LOGIN', this.$store.getters.isLoggedIn);
            if (this.$store.getters.isLoggedIn) {
                this.$store.dispatch('logout');
            }
            this.$store.dispatch('login', { idToken }).then(() => {

                if (null !== localStorage.getItem('currentUri')) {
                    /*console.log(
                        'Login currentUri exists in localStorage, trying to redirect',localStorage.getItem('currentUri')
                    );*/
                    let currentUri = localStorage.getItem('currentUri');
                    localStorage.removeItem('currentUri');
                    if (currentUri != '/') {
                        this.$router.push({ path: currentUri });
                    } else {
                        this.$router.push({
                            path: '/dashboard',
                            query: {
                                filter: 'mine',
                            },
                        });
                    }
                } else {
                    this.$router.push({
                        path: '/dashboard',
                        query: {
                            filter: 'mine',
                        },
                    });
                }
            }).catch((e) => {
                Swal.fire({
                    title: this.$t('user_login_failed'),
                    html: this.$t(e.data),
                    confirmButtonText: this.$t('userProfile.leave_school_continue')
                }).then((result) => {
                    this.logout();
                });
                    
                    //this.errorLogin = true;
                });
        },
        toogleAgeConsent() {
            this.ageConsent = !this.ageConsent;
            this.registrationData.ageConsent = this.ageConsent
        },
        toogleTOS() {
            this.TOSaccepted = !this.TOSaccepted;
            this.registrationData.TOSaccepted = this.TOSaccepted
        },
        checkPasswordField() {
            this.errorsFound.pw1 = null
            this.errorsFound.pw2 = null
            this.showPw1Error = false;
            this.showPw2Error = false;

            const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@.#$!%*?&])[A-Za-z\d@.#$!%*?&]{8,}$/;
            // let regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@.#$!%*?&])[A-Za-z\d@.#$!%*?&]{8,15}$/;


            if (this.registrationData.password !== this.registrationData.pw2) {
                this.errorsFound.pw1 = this.$t('registration_error_pw_different')
                this.errorsFound.pw2 = this.$t('registration_error_pw_different')
                this.showPw1Error = true
                this.showPw2Error = true
                return false
            }
            else if (regex.test(this.registrationData.password)) {
                this.errorsFound.pw1 = null
                this.errorsFound.pw2 = null
                this.showPw1Error = false;
                this.showPw2Error = false;
                return true
            } else {
                this.errorsFound.pw1 = this.$t('registration_error_password')
                this.showPw1Error = true
                this.errorsFound.pw2 = this.$t('registration_error_password')
                this.showPw2Error = true
                return false
            }

            return false

        },
        async checkForm() {
            if (!this.hasErrors) {
                // console.log("no errors. sending form")
                await register(this.registrationData).catch((e) => {
                    // console.log("error registering user", e)
                    Swal.fire({
                        title: this.$t('user_registration_failed'),
                        html: this.$t(e.data),
                        confirmButtonText: this.$t('userProfile.leave_school_continue')
                    }).then((result) => {
                        this.logout();
                        this.registrationData = {
                            name: '',
                            surname: '',
                            email: '',
                            username: '',
                            password: '',
                            pw2: '',
                            TOSaccepted: false,
                            ageConsent: false,
                            type: 'LOCAL',
                        };
                        this.showRegistration = false;
                    });

                })
                    .then((response) => {
                        // console.log(response)
                        if (response && response.status == "200") {
                            // console.log("user registered")
                            this.showRegistration = false
                            this.registrationOk = true
                            this.showValidation = true
                            /*Swal.fire({
                                title: this.$t('user_registered_successfuly_title'),
                                text: this.$t('user_registered_successfuly_text'),
                                confirmButtonText: this.$t('userProfile.leave_school_continue')
                            }).then((result) => {
                            });*/
                        }
                    });

            } else {
                console.log("hi han errors")
            }


        },
        checkNameField() {
            this.errorsFound.name = null
            this.showNameError = false;
            if (!this.registrationData.name.length || !this.registrationData.name.trim()) {
                this.errorsFound.name = this.$t('registration_error_name')
                this.showNameError = true;
                return false
            }
            return true
        },
        checkSurnameField() {
            this.errorsFound.surname = null
            this.showSurnameError = false;
            if (!this.registrationData.surname.length || !this.registrationData.surname.trim()) {
                this.errorsFound.surname = this.$t('registration_error_surname')
                this.showSurnameError = true
                return false
            }
            return true
        },
        async checkUsernameField() {
            this.errorsFound.username = null
            this.showUsernameError = false

            if (!this.registrationData.username || this.registrationData.username.trim().length < 2) {
                this.errorsFound.username = this.$t('registration_error_username_too_short') //"Cal introduir un nom d'usuari de, com a mínim 2, caracters"
                this.showUsernameError = true
                return false
            } else {
                this.registrationData.username = this.registrationData.username.trim()
                await checkUsername({ 'username': this.registrationData.username })
                    .catch((e) => {
                        // console.log('error on check username ', e.data)
                        this.errorsFound.username = this.$t('registration_error_username_already_exists') //"Aquest nom d'usuari ja existeix"
                        this.showUsernameError = true
                        return false
                    })
                    .then((response) => {
                        if (response && response.status == 200) {
                            this.errorsFound.username = null
                            this.showUsernameError = false
                            return true
                        }
                    })
            }
            return false
        },
        async checkEmailField() {
            this.errorsFound.email = null
            this.showEmailError = false

            let isValidEmail;

            if (!this.registrationData.email || this.registrationData.email.trim().length < 2) {
                this.errorsFound.email = this.$t('registration_error_email_innvalid') //"Cal introduir una adreça de correu electrònic vàlida"
                this.showEmailError = true
                return false
            }
            this.registrationData.email = this.registrationData.email.trim()
            // console.log("checking ", this.registrationData.email)
            const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            if (regex.test(this.registrationData.email)) {
                await checkEmail({ 'email': this.registrationData.email })
                    .catch((e) => {
                        // console.log('error on check email ', e.data)
                        this.errorsFound.email = this.$t('registration_error_email_already_exists') //"Aquesta adreça de correu electrònic ja exsteix"
                        this.showEmailError = true
                        return false
                    })
                    .then((response) => {
                        if (response && response.status == 200) {
                            this.errorsFound.email
                            this.showEmailError = false
                            return true
                        }
                    })
            } else {
                this.errorsFound.email = this.$t('registration_error_email_innvalid') //"Cal introduir una adreça de correu electrònic vàlida"
                this.showEmailError = true
                return false
            }

            return false

        },
        
        async sendCode() {
            const regex = /^[0-9A-F]{8}-[0-9A-F]{4}-[4][0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i;
            if (!regex.test(this.activationCode)) {
                // console.log("error in regex")
                this.showActivationCodeError = true;
            } else {
                // console.log("activation code ok")
                this.showActivationCodeError = false
                await activateUser({ 'activationCode': this.activationCode })
                .catch((e) => {
                    // console.log("error activating user", e)
                    if (e.status && e.status == '404') {
                        if (e.data) {
                            this.showActivationCodeError = true;
                        }
                    }

                })
                .then((response) => {
                    // console.log(response)
                    if (response && response.status == "200") {
                        this.showActivationCodeError = false;
                        // console.log("user activated")
                        this.registrationOk = false
                        this.showValidation = false
                        // console.log(response.data)
                        this.$store.dispatch('loginFromCode', response.data).then(() => {
                            /*this.$router.push({
                                path: '/dashboard',
                                query: {
                                    filter: 'mine',
                                },
                            });*/
                            if(!this.$store.getters.hasMinimumAge || !this.$store.getters.TOSAccepted || this.$store.getters.personalData.invitation ){
                                // console.log("Show confirm age modal");
                                if(this.$store.getters.hasMinimumAge){
                                    this.ageConsent = this.$store.getters.hasMinimumAge;
                                }
                                if(this.$store.getters.TOSAccepted){
                                    this.TOSaccepted = this.$store.getters.TOSAccepted;
                                }
                                this.showAgeModal=true;
                            }else{
                                // console.log("to enter plattform")
                                this.enterPlatform();
                            }
                        });

                    }

                });
            }
        },
        logout(){
            this.$store.dispatch('logout');
        },
        switchLocale(locale) {
            if (this.$i18n.locale !== locale) {
                this.$i18n.locale = locale;
            }
        },
        updateProfile(){
            if(this.ageConsent && this.TOSaccepted){
                let userProfile = {...this.$store.getters.personalData};
                userProfile.hasMinimumAge = this.ageConsent;
                userProfile.TOSAccepted = this.TOSaccepted;
                // console.log(userProfile)
                if (this.invitationConfirmed) {
                    userProfile.invitationAccepted = true;
                } else if (this.invitationdeclined) {
                    userProfile.invitationDeclined = true;
                }
                this.$store.dispatch('updateProfile', userProfile).then((response) => {
                    // console.log("profile updated",response)
                    this.enterPlatform();
                }).catch(() => {
                    // console.log("in catch")
                    this.$router.push({
                        name: 'home_login',
                    });
                });
            }
        },
        enterPlatform() {
            // console.log("in enter plattform", this.$store.getters.personalData)
            if (this.$store.getters.personalData.school && this.$store.getters.personalData.school.email=="eduloc360@gmail.com") {
                Swal.fire({
                    html: this.$t('eduloc360_base_entity_alert'),
                    confirmButtonText: this.$t('userProfile.leave_school_continue')
                }).then((result) => {
                    /*this.$router.push({
                        name: 'home_login',
                    });*/
                });
            }
            if (null !== localStorage.getItem('currentUri')) {
                let currentUri = localStorage.getItem('currentUri');
                localStorage.removeItem('currentUri');
                if(currentUri!='/'){
                    this.$router.push({ path: currentUri });
                }else{
                    this.$router.push({
                        path: '/dashboard',
                        query: {
                            filter: 'mine',
                        },
                    });
                }
            } else {
                this.$router.push({
                    path: '/dashboard',
                    query: {
                        filter: 'mine',
                    },
                });
            }
        },
        confirmInvitation() {
            this.invitationConfirmed = true;
            this.invitationdeclined = false;
        },
        declineInvitation() {
            this.invitationConfirmed = false;
            this.invitationdeclined = true;
        },
        async sendForgotPasswordRequest() {
            if (!this.forgotPasswordEmail) {
                return;
            }
            this.showForgotPasswordError = false;
            const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            if (emailRegex.test(this.forgotPasswordEmail)) {
                // password_requested_at
                //confirmation_token
                await requestPassword({ email: this.forgotPasswordEmail })
                    .catch((e) => {
                        // console.log("error requesting password", e)
                        this.showForgotPasswordError = true;
                    })
                    .then((response) => {
                        // console.log(response)
                        if (response && response.status == "200") {
                            // console.log("password requested")
                            this.changePassword = false;
                            this.changePasswordCodeInput = true;
                        }
                    });
            } else {
                this.showForgotPasswordError = true;
            }
        },
        async sendForgotPasswordRequestCode() {
            if (!this.forgotPasswordCode) {
                return;
            }
            if (!this.password || !this.pw2) {
                return;
            }
            if (!this.hasUpdatePasswordErrors) {
                // console.log("no errors. sending change password")
                await changePassword({
                    code: this.forgotPasswordCode,
                    password: this.password
                }).catch((e) => {
                    console.log("error changing password", e)
                })
                    .then((response) => {
                        // console.log(response)
                        if (response && response.status == "200") {
                            // console.log("password changed")
                            this.pwChanged = true;
                        }
                    });

            } else {
                console.log("hi han errors")
            }

        },
        checkChangePasswordField() {
            this.forgoterrorsFound.pw1 = null
            this.forgoterrorsFound.pw2 = null
            this.showForgotPw1Error = false;
            this.showForgotPw2Error = false;

            const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@.#$!%*?&])[A-Za-z\d@.#$!%*?&]{8,}$/;
            // let regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@.#$!%*?&])[A-Za-z\d@.#$!%*?&]{8,15}$/;

            if (this.password.length > 0 || this.pw2.length > 0) {
                if (this.password !== this.pw2) {
                    this.forgoterrorsFound.pw1 = this.$t('registration_error_pw_different')
                    this.forgoterrorsFound.pw2 = this.$t('registration_error_pw_different')
                    this.showForgotPw1Error = true
                    this.showForgotPw2Error = true
                    return false
                }
                else if (regex.test(this.password)) {
                    this.forgoterrorsFound.pw1 = null
                    this.forgoterrorsFound.pw2 = null
                    this.showForgotPw1Error = false;
                    this.showForgotPw2Error = false;
                    return true
                } else {
                    this.forgoterrorsFound.pw1 = this.$t('registration_error_password')
                    this.showForgotPw1Error = true
                    this.forgoterrorsFound.pw2 = this.$t('registration_error_password')
                    this.showForgotPw2Error = true
                    return false
                }
            } 

            return false

        },
        closeChangePasswordModal() {
            this.changePasswordCodeInput = false;
            this.pwChanged = false;
        }
    },
}

</script>

<style scoped>
@import '../assets/css/swal-eduloc.css';
.button {
    border-radius: 6px;
}
.logo{
    display: inline-block;
    float: left;
}
.logo-text{
    display: inline-block;
    width: 100%;
}

.input{
    border-radius: 6px;
    color: #000000;
    border-color: #000000;
}
.input:not(.is-danger):hover{
    border-radius: 6px;
    color: #000000;
    border-color: #000000;
}


.input::placeholder {
  color: #000000;
}

.label {
  color: #000000;
}

.button[disabled]:hover{
    color: #000000;
    background-color: #ffffff;
}

.registration /deep/.modal-card-head.is-block{
    padding-bottom: 0;
}

.activation /deep/.modal-card-body{
    padding-top: 0 !important;
}

.consent /deep/.modal-card-head.is-block{
    background-color: var(--eduloc-red);
}

.consent /deep/.modal-card-body{
    padding: 1.5rem !important;
}

</style>
